import React from 'react';
import PropTypes from 'prop-types';

import { TranslatedTextMessage } from './TranslatedTextMessage';

const StateSelector = ({ selector, selectedState, callback }) => {
  const rawSelect = states => {
    const options = states.map(state => {
      return (
        <option value={state.value} key={state.value}>
          {state.label}
        </option>
      );
    });

    return (
      <div className="age-gate__state-selector-wrapper">
        <select
          id="age-gate-states"
          name="age-gate-states"
          className="Field__input age-gate__state-selector"
          value={selectedState.value}
          onChange={e => {
            callback({
              value: e.target.value,
              label: e.target.options[e.target.selectedIndex].text,
            });
          }}
        >
          {options}
        </select>
      </div>
    );
  };
  return (
    <React.Fragment>
      <TranslatedTextMessage id={'SELECT_STATE_COPY'} />
      {rawSelect(selector.states)}
    </React.Fragment>
  );
};

StateSelector.propTypes = {
  selector: PropTypes.object.isRequired,
  selectedState: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
};

export default StateSelector;
